import React from 'react'
import Githubimage from "./github.png"

export default function Github() {
  return (
    <img src={Githubimage} width="20px" height="20px"></img>
  )
}
